import * as types from "./types";

function obtenerListadoCobros(payload) {
  return { type: types.FETCH_LISTADO, payload };
}

function resetListadoCobros() {
  return { type: types.RESET };
}

function limpiarActividadSeleccionada(params) {
  return { type: types.CLEAR_ACTIVIDAD_SELECCIONADA };
}

function putActividadSeleccionada(payload) {
  return { type: types.PUT_ACTIVIDAD_SELECCIONADA, payload };
}

/*---*/
export {
  obtenerListadoCobros,
  resetListadoCobros,
  limpiarActividadSeleccionada,
  putActividadSeleccionada
};



// WEBPACK FOOTER //
// ./src/ducks/cobros/actions.js